<template>
  <div></div>
</template>

<script>
import pdfMake from "pdfmake";
import htmlToPdfmake from "html-to-pdfmake";
import pdfFonts from "../../../../assets/build/vfs_fonts";

import apiConfig from "../../../../config/api";
import whApi from "@/api/warehouse/";

import moment from "moment";

import { Decode, Encode } from "@/services";
import userApi from "@/api/user/";
import { toFixed } from "ant-design-vue/lib/input-number/src/utils/MiniDecimal";

import { ArabicNumberToText } from "../../../../utils/numberToText";

import JsBarcode from "jsbarcode/bin/JsBarcode";

import numbro from "numbro";

export default {
  props: {
    dataExportPdf: Object,
  },
  data: () => ({
    jsonExport: [],

    newDataTable: [],

    user: "",
    numberToTh: "",
  }),
  async created() {
    console.log(this.dataExportPdf);
    await this.getAllMainPd();
    await this.getAllSubPd();
    await this.groupDateExport();
  },

  methods: {
    groupDateExport() {
      let newMainPd = {};
      let newSubPd = {};

      this.dataExportPdf.forEach((element, index) => {
        newMainPd = this.mainProduct.find(
          (data) => data.id === element.product.mainProductGroupId
        );

        newSubPd = this.subProduct.find(
          (data) => data.id === element.product.subProductGroupId
        );

        !newMainPd
          ? ""
          : !newSubPd
          ? ""
          : this.jsonExport.push({
              no: index + 1,
              productCode: element.product.product_code,
              productName: element.product.product_name,
              productBarcode: element.product.product_barcode,
              mainProduct: newMainPd.main_product_group_name,
              subProduct: newSubPd.sub_product_group_name,
              productPOG: element.product.product_pog,
              retailPrice: numbro(element.product.product_retail_price).format({
                thousandSeparated: true,
                mantissa: 2,
              }),
              productQty: element.product.product_bring_qty,
              expireCode: element.expire_no,
              expireDate: element.expire_date,
            });
      });

      this.setDataToTable();
    },

    async getAllMainPd() {
      // this.loading = true;
      let responseData = {};
      try {
        responseData = await whApi.mainProduct.getAll();
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.mainProduct = responseData.data;
        // this.loading = false;
      }
    },

    async getAllSubPd() {
      // this.loading = true;
      let responseData = {};
      try {
        responseData = await whApi.subProduct.getAll();
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.subProduct = responseData.data;
        // this.loading = false;
      }
    },

    exports() {
      const newWindow = window.open("", "_blank");

      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        Roboto: {
          normal: "Kanit-Regular.ttf",
          bold: "Kanit-Medium.ttf",
          italics: "Kanit-Medium.ttf",
          bolditalics: "Kanit-Medium.ttf",
        },
      };

      console.log(this.jsonExport);

      const html = [
        {
          text: "รายการสินค้าหมดอายุ",
          fontSize: 16,
          bold: true,
          margin: [0, 0, 0, 10],
        },

        // TABLE
        {
          table: {
            // width: "100%",
            widths: [
              "3%",
              "auto",
              "37%",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
            ],
            body: this.newDataTable,
          },
        },
      ];

      const pdfData = {
        content: html,
        pageOrientation: "landscape",
      };
      pdfMake.createPdf(pdfData).open({}, newWindow);
      this.$emit("generatedFile");
    },

    setDataToTable() {
      this.jsonExport.forEach((element, index) => {
        if (index === 0) {
          this.newDataTable.push(
            [
              {
                fontSize: 9,
                text: "#",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "รหัสสินค้า",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "ชื่อสินค้า",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "Barcode",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "กลุ่มสินค้าหลัก",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "กลุ่มสินค้ารอง",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "POG",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "ราคาปลีก",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "Qty",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "Expire Code",
                alignment: "center",
              },
              {
                fontSize: 9,
                text: "วันหมดอายุ",
                alignment: "center",
              },
            ],
            [
              {
                text: element.no,
                fontSize: 9,
                fillColor: "#eaeced",
              },
              {
                text: element.productCode,
                fontSize: 9,
                fillColor: "#eaeced",
              },
              {
                text: element.productName,
                fontSize: 9,
                fillColor: "#eaeced",
              },
              {
                text: element.productBarcode,
                fontSize: 9,
                fillColor: "#eaeced",
              },
              {
                text: element.mainProduct,
                fontSize: 9,
                fillColor: "#eaeced",
              },
              {
                text: element.subProduct,
                fontSize: 9,
                fillColor: "#eaeced",
              },
              {
                text: element.productPOG,
                fontSize: 9,
                fillColor: "#eaeced",
              },
              {
                text: element.retailPrice,
                fontSize: 9,
                fillColor: "#eaeced",
                alignment: "right",
              },
              {
                text: element.productQty,
                fontSize: 9,
                fillColor: "#eaeced",
                alignment: "right",
              },
              {
                text: element.expireCode,
                fontSize: 9,
                fillColor: "#eaeced",
                alignment: "right",
              },
              {
                text: element.expireDate,
                fontSize: 9,
                fillColor: "#eaeced",
                alignment: "right",
              },
            ]
          );
        } else {
          this.newDataTable.push([
            {
              text: element.no,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
            },
            {
              text: element.productCode,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
            },
            {
              text: element.productName,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
            },
            {
              text: element.productBarcode,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
            },
            {
              text: element.mainProduct,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
            },
            {
              text: element.subProduct,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
            },
            {
              text: element.productPOG,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
            },
            {
              text: element.retailPrice,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
              alignment: "right",
            },
            {
              text: element.productQty,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
              alignment: "right",
            },
            {
              text: element.expireCode,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
              alignment: "right",
            },
            {
              text: element.expireDate,
              fontSize: 9,
              fillColor: index % 2 === 0 ? "#eaeced" : "",
              alignment: "right",
            },
          ]);
        }
      });

      this.exports();
    },
  },
};
</script>
